<template>
  <v-layout row wrap>
    <v-flex xs12 md6 class="agreementinput--options">
      <div class="agreementinput--options-group">
        <div class="agreementinput--options-option">
          <input
            v-model="agreement.newStatus"
            v-validate="'required'"
            :data-vv-as="`${agreement.title} agree/decline`"
            :id="`${agreement.id}_agree`"
            :name="`${agreement.id}_agreement`"
            class="agreementinput--input agree"
            type="radio"
            value="SIGNED">
          <label :for="`${agreement.id}_agree`">Agreed</label>
        </div>

        <div class="agreementinput--options-option decline">
          <input
            v-model="agreement.newStatus"
            :id="`${agreement.id}_declined`"
            :name="`${agreement.id}_agreement`"
            class="agreementinput--input decline"
            type="radio"
            value="DECLINED">
          <label :for="`${agreement.id}_declined`">Decline Agreement</label>
        </div>
      </div>
    </v-flex>

    <v-flex xs12 md6>
      <label for="signature">Signature*</label>
      <input
        v-model="agreement.signature"
        v-validate="'required'"
        :data-vv-as="`${agreement.title} signature`"
        :name="`${agreement.id}_signature`"
        class="agreementinput--signature"
        id="signature"
        type="text"/>
      <div class="agreementinput--signature-instructions">
        <p>Type your full name to sign.</p>
        <p>This is a legally binding signature.</p>
      </div>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  props: {
    agreement: {
      type: Object,
      required: true,
    },
  },
  inject: ['$validator'],
};
</script>

<style lang="scss" scoped>
@import '../../styles/vars/theme';
@import '../../styles/vars/typography';

p {
  color: rgba($theme-color-black, 0.6);
  font-size: 1.286rem;
  margin: 0;
  padding: 0;
}

.agreementinput {
  &--options {
    align-items: center;
    display: flex;
    justify-content: center;
    margin: 0;

    &-group {
      label,
      input {
        display: inline-block;
      }

      label {
        padding: 0 5px;
      }
    }

    &-option {
      display: inline-block;
      vertical-align: middle;

      &.decline {
        margin-left: 20px;
      }
    }
  }

  &--signature {
    background: $theme-color-white;
    margin: 5px 0;
    width: 100%;

    &-instructions {
      p {
        font-size: 1rem;
      }
    }
  }
}

@media all and (max-width: 944px) {
  .agreementinput {
    &--options {
      justify-content: flex-start;
      margin-bottom: 20px;
      padding: 0;
    }
  }
}
</style>
